import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { AspectRatio, Image as Image$1 } from '@chakra-ui/react';
var _excluded = ["align", "aspectRatio", "description", "height", "id", "path", "sizes", "srcSet", "width", "objectFit", "fallbackSrc", "imageProps"];
var Image = function Image(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'center' : _ref$align,
    aspectRatio = _ref.aspectRatio,
    description = _ref.description,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 'auto' : _ref$height,
    id = _ref.id,
    path = _ref.path,
    sizes = _ref.sizes,
    srcSet = _ref.srcSet,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100%' : _ref$width,
    objectFit = _ref.objectFit,
    fallbackSrc = _ref.fallbackSrc,
    _ref$imageProps = _ref.imageProps,
    imageProps = _ref$imageProps === void 0 ? {} : _ref$imageProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  /**
   * DOM
   */
  var props = _objectSpread2({
    align: align,
    id: id,
    src: path,
    alt: description,
    sizes: sizes,
    srcSet: srcSet,
    objectFit: objectFit
  }, imageProps);
  if (aspectRatio) {
    return /*#__PURE__*/React.createElement(AspectRatio, {
      "data-object-type": "core-aspect-ratio",
      ratio: aspectRatio,
      w: width,
      h: height
    }, /*#__PURE__*/React.createElement(Image$1, _extends({
      "data-object-type": "core-image",
      fallbackSrc: fallbackSrc,
      objectFit: objectFit
    }, props)));
  }
  return /*#__PURE__*/React.createElement(Image$1, _extends({
    "data-object-type": "core-image",
    fallbackSrc: fallbackSrc,
    objectFit: objectFit
  }, props, {
    htmlWidth: width,
    htmlHeight: height
  }, rest));
};
Image.displayName = "Image";
export { Image };